// Private block carrying producer-measured deformation validity (PS3.5 7.8.1).
export const DVF_QA_PRIVATE_CREATOR = 'MVision AI DVF QA';
export const DVF_QA_GROUP = 0x0071;
export const DVF_QA_MIN_JACOBIAN = 0x01;
export const DVF_QA_MAX_JACOBIAN = 0x02;
export const DVF_QA_FOLDING_FRACTION = 0x03;
export const DVF_QA_GRID_DIMENSIONS = 0x05;
